// @flow

import React, { PureComponent, createContext } from 'react';
import { Query } from 'react-apollo';

import { AuthConsumer } from '../../contexts/Auth';
import type { AuthInfo as AuthInfoType } from '../../contexts/Auth';
import type { QueryRenderProps } from 'react-apollo';

import query from './UserInfo.graphql';

type Result = QueryRenderProps<UserInfoQuery>;

type Props = {
  children: any,
  auth: AuthInfoType,
  result: Result,
  isAuthenticated: boolean,
};

type State = {
  auth: AuthInfoType,
  result: Result,
};

const initialContext = {
  isAuthenticated: false,
  userInfo: null,
  refetch: () => {},
};

const { Provider, Consumer } = createContext(initialContext);

class UserInfo extends PureComponent<Props, State> {
  render() {
    const { isAuthenticated } = this.props.auth;
    const { loading, data, refetch } = this.props.result;

    // Prevent rendering till data is fetched
    if (loading) {
      return null;
    }

    const userInfo = data && data.userInfo ? data.userInfo : null;
    // This comment changes data content, make sure to test before deleting :(

    const subscriptionIsActive =
      userInfo &&
      (userInfo.subscription.isActive || userInfo.isChildSubscription);

    const subscriptionIsCanceled =
      subscriptionIsActive && userInfo.subscription.isCanceled;

    window.CONFIG.business_user =
      (subscriptionIsActive &&
        !subscriptionIsCanceled &&
        userInfo.subscription.activatedPlan) ||
      'free';

    if (userInfo && isAuthenticated) {
      window.CONFIG.user_id = userInfo.id;
    }

    const subscriptionIsBasic =
      subscriptionIsActive &&
      userInfo.subscription.activatedPlan ===
        process.env.REACT_APP_PLAN_PREMIUM;

    const subscriptionIsPro =
      subscriptionIsActive &&
      userInfo.subscription.activatedPlan === process.env.REACT_APP_PLAN_PRO;

    const subscriptionIsChild = userInfo && userInfo.isChildSubscription;

    return (
      <Provider
        value={{
          isAuthenticated,
          userInfo,
          refetch,
          subscriptionIsActive,
          subscriptionIsBasic,
          subscriptionIsPro,
          subscriptionIsChild,
          subscriptionIsCanceled,
        }}
      >
        {this.props.children}
      </Provider>
    );
  }
}

export { Consumer as UserInfoConsumer };

// Auth context lifecycle consuming
export default (props: any) => (
  <AuthConsumer>
    {(auth: AuthInfoType) => (
      <Query query={query}>
        {(result: Result) => {
          return <UserInfo {...props} auth={auth} result={result} />;
        }}
      </Query>
    )}
  </AuthConsumer>
);



// WEBPACK FOOTER //
// ./src/contexts/UserInfo/index.js